webpackJsonp([114276838955818,60335399758886],{

/***/ 104:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(207);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(104);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _headerModule = __webpack_require__(302);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	var _hamburger = __webpack_require__(625);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	var _aTown_logo_dark = __webpack_require__(125);
	
	var _aTown_logo_dark2 = _interopRequireDefault(_aTown_logo_dark);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getLinks(closeMenu) {
	  return [_react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: "/", onClick: closeMenu, key: 1 },
	    _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.link },
	      "Home"
	    )
	  ), _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: "/subscribe", onClick: closeMenu, key: 2 },
	    _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.link },
	      "Subscribe"
	    )
	  ), _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: "/patreon", onClick: closeMenu, key: 3 },
	    _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.link },
	      "Patreon"
	    )
	  ), _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: "/about", onClick: closeMenu, key: 4 },
	    _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.link },
	      "About"
	    )
	  ), _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: "/shows", onClick: closeMenu, key: 5 },
	    _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.link },
	      "Shows"
	    )
	  ), _react2.default.createElement(
	    "a",
	    { href: "https://teespring.com/atownfm", key: 6 },
	    _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.link },
	      "Store"
	    )
	  )];
	}
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isMenuOpen: false
	    };
	    return _this;
	  }
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var toggleMenu = function toggleMenu() {
	      _this2.setState({ isMenuOpen: !_this2.state.isMenuOpen });
	    };
	
	    var closeMenu = function closeMenu() {
	      _this2.setState({ isMenuOpen: false });
	    };
	
	    var menu = this.state.isMenuOpen ? _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.menuPopup, onClick: closeMenu },
	      getLinks(closeMenu)
	    ) : null;
	
	    return _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.header },
	      _react2.default.createElement(
	        "div",
	        { className: _headerModule2.default.image },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/" },
	          _react2.default.createElement("img", { src: _aTown_logo_dark2.default, alt: "A-Town FM" })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _headerModule2.default.links },
	        getLinks(closeMenu)
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _headerModule2.default.menu, onClick: toggleMenu },
	        _react2.default.createElement("img", { src: _hamburger2.default, alt: "Menu" })
	      ),
	      menu
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	;
	module.exports = exports["default"];

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/a-town_logo_dark.7fbe5015.jpg";

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAATCAYAAABhh3Y4AAAAAXNSR0IArs4c6QAAAKlJREFUSA1j+P//fwMQvwdiWoLzQMMVGIHEBwYGBn4gpjUoZALacIDWtkDNP8AIYgB9ZwCkBKCCtKAuMDIygkJwFFAeArA4cwAa9Z9y43Ca8BAYZw9ASX8DUIk/TmXUkwgEJX0H6pmH1yQFkGUNQPwQrzLKJTcCjQCF4CgYYiEASvoOQDfb09jdoHJxIQuQWADE8kBMa/ARlPTpBkDBaAC0LYDGNoKCcQEAJSSOL4f9CeAAAAAASUVORK5CYII="

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SEO = __webpack_require__(21);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Header = __webpack_require__(205);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_SEO2.default, null),
	    _react2.default.createElement(_Header2.default, null),
	    children()
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-styles----header-module---header---1C-DW","image":"src-styles----header-module---image---2ijAT","links":"src-styles----header-module---links---uYR05","link":"src-styles----header-module---link---1EMsL","menu":"src-styles----header-module---menu---1Zp9j","menuPopup":"src-styles----header-module---menuPopup---2v0Xa"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-fc3cd1b2e863054f851a.js